import {
  Box,
  CardContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddAddress from "./AddAddress";
import { memo } from "react";

function Address({data,setAddress}) {

  const { t, i18n } = useTranslation();
  const [selectedId, setSelectedId] = useState(null);
  const selected = data?.find((address) => address.fav_id === selectedId) || data?.[0];

  const handleAddressChange = (event) => {
    const address = data.find((address) => String(address.fav_id) === event.target.value);
    if (address) setSelectedId(address.fav_id);
  };

  useEffect(() => {
    if (selected) {
      setAddress({ ...selected.address_data, fav_id: selected.fav_id });
    } else {
      setAddress({ fav_id: null });
    }
  }, [selected, setAddress]);

  return (
    <>
        <CardContent>
          <Box sx={{display:"flex",paddingBottom:"20px"}}>
            <Typography variant="h6" sx={{width:"90%"}}  gutterBottom>
              {t("checkout.select_address")}
            </Typography>
            <AddAddress sx={{width:"10%"}}  />
          </Box>
          {data && data.length > 0 && (
              <Box  className="address-section">
                <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={selected?.fav_id ?? ""}
                      name="radio-buttons-group">
                      {data.map((val,idx) => {
                        return (<FormControlLabel key={idx} value={val.fav_id} control={<Radio />} checked={selected?.fav_id === val.fav_id}
                        label={
                          <Box className="address-border">
                            <Typography variant="p" component="b" >{val?.address_data?.friendly_name}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              <b> {t("checkout.city")} </b>{val?.address_data?.city ? (
                                <>
                                  {val?.address_data?.city}
                                </>
                              ) : t("checkout.no_additional_details_provided") 
                              }
                          </Typography>

                            <Typography variant="body2" color="textSecondary">
                              <b>{t("checkout.area")}</b> {val?.address_data?.area ? (
                                <>
                                {val?.address_data?.area}
                                </>
                              ) : t("checkout.no_additional_details_provided") 
                              }
                            </Typography>

                          <Typography variant="body2" color="textSecondary">
                              <b>{t("checkout.mobile")} </b> {val?.address_data?.mobile ? (
                                <>
                                {val?.address_data?.mobile}
                                </>
                              ) :  t("checkout.no_additional_details_provided") 
                              }
                          </Typography>

                          </Box>
                          }
                            onChange={(event) => handleAddressChange(event)} />)
                      })}
            
                    </RadioGroup>
                  </FormControl>
              </Box>
            )}
        </CardContent>
     
    </>
  );
}

export default memo(Address);
